module.exports = __webpack_public_path__ + "images/e842f5f.png";